import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function AirportDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Airport")}
      endpoint={`/airports/${props.match.params.id}/`}
      successRoute={reverse("airportList")}
      errorRoute={reverse("airportDetail", { id: props.match.params.id })}
    />
  )
}

AirportDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
